import React, { type ReactNode } from "react";
import { View, Platform, type ViewStyle, type StyleProp } from "react-native";
import { useSafeAreaInsets, type EdgeInsets } from "react-native-safe-area-context";
import { StyleSheet, useUnistyles } from "react-native-unistyles";

type ScreenContainerProps = {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
  edges?: Array<keyof EdgeInsets>;
  backgroundColor?: string;
  /** Web: caps and centres content. Auth/onboarding forms use this so they
   *  don't stretch across wide viewports. */
  contentMaxWidth?: number;
};

export function ScreenContainer({
  children,
  style,
  edges = ["top", "bottom", "left", "right"],
  contentMaxWidth,
}: ScreenContainerProps) {
  const insets = useSafeAreaInsets();
  const { theme } = useUnistyles();

  const safeAreaStyle = {
    paddingTop: edges.includes("top") ? insets.top : 0,
    paddingBottom: edges.includes("bottom") ? insets.bottom : 0,
    paddingLeft: edges.includes("left") ? insets.left : 0,
    paddingRight: edges.includes("right") ? insets.right : 0,
    backgroundColor: theme.colors.background,
  };

  const contentMaxWidthStyle =
    contentMaxWidth && Platform.OS === "web" ?
      { maxWidth: contentMaxWidth, width: "100%" as const, alignSelf: "center" as const }
    : null;

  return <View style={[styles.container, safeAreaStyle, contentMaxWidthStyle, style]}>{children}</View>;
}

const styles = StyleSheet.create((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
  },
}));
